{
  "infoStocksDescription": {
    "title": "Description",
    "error": "Failed to load company information",
    "ceo": "CEO",
    "founded": "Founded",
    "employees": "Employees",
    "website": "Website",
    "headquarters": "Headquarters",
    "exchange": "Exchange",
    "industry": "Industry",
    "sector": "Sector"
  }
}
